<template>
  <a-modal title="操作" style="top: 20px" :width="1100" v-model="visible" :confirmLoading="confirmLoading"
    :hideOnSinglePage="true" @ok="handleSubmit">
    <!-- 入库 -->
    <div v-show="judge != 1">
      <a-form :form="form">
        <a-form-item style="display: none">
          <a-input v-decorator="['storageAccessoryId']" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 仓库类型" style="position: relative">
          <span style="color: red; position: absolute; left: -78px">*</span>
          <a-select @change="onchange4In" v-model="storeType">
            <a-select-option value="0">主库</a-select-option>
            <a-select-option value="1">机构分库</a-select-option>
            <a-select-option value="2">师傅分库</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="* 仓库名称" style="position: relative">
          <span style="color: red; position: absolute; left: -78px">*</span>
          <a-select @change="onchange" v-model="storeId" showSearch optionFilterProp="children"
            :filterOption="filterOption">
            <a-select-option v-for="item in boxLis2" :value="item.storeId">{{ item.storeName }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件" style="position: relative">
          <span style="color: red; position: absolute; left: -50px">*</span>
          <a-select @change="onchange2" v-model="accessoryId" showSearch optionFilterProp="children"
            :filterOption="filterOption" allowClear="true">
            <a-select-option v-for="item in boxLis4" :value="item.accessoryId">{{ item.accessoryType }} _ {{
                item.accessoryName
            }} _ {{ item.accessoryCategory }} _
              {{ item.accessorySpecification }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入库数量" style="position: relative">
          <span style="color: red; position: absolute; left: -78px">*</span>
          <a-input v-model="accessoryNumber" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="锁安入库单价" style="position: relative">
          <span style="color: red; position: absolute; left: -108px">*</span>
          <a-input @change="onchange3" v-model="unityPrice" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅配件单价" style="position: relative">
          <span style="color: red; position: absolute; left: -108px">*</span>
          <a-input :disabled="storeType != 2" v-model="masterUnityPrice" />
        </a-form-item>

        <a-button type="primary" style="margin-left: 100px" icon="plus" @click="thresHold2">设置阈值</a-button>
        <a-form-item v-if="threshold == 1" :labelCol="labelCol" :wrapperCol="wrapperCol" label="私有库存">
          <a-input v-model="privateNumber" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预警值">
          <a-input v-model="warningNumber" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input v-model="remark" />
        </a-form-item>
        <div>
          <a-button class="editable-add-btn" @click="handleAdd">添加</a-button>

          <a-table bordered :dataSource="dataSource" :columns="columns">
            <template slot="warningNumber" slot-scope="text, record">
              <editable-cell :text="text" @change="onCellChange(record.key, 'warningNumber', $event)" />
            </template>

            <template slot="remark" slot-scope="text, record">
              <editable-cell :text="text" @change="onCellChange(record.key, 'remark', $event)" />
            </template>

            <template slot="operation" slot-scope="text, record">
              <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
      </a-form>
    </div>
    <!-- 出库 -->
    <div v-show="judge == 1">
      <a-form :form="form">
        <a-form-item style="display: none">
          <a-input v-decorator="['storageAccessoryId']" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仓库类型">
          <a-select v-model="storeType" @change="onchange4">
            <a-select-option value="0">主库</a-select-option>
            <a-select-option value="1">机构分库</a-select-option>
            <a-select-option value="2">师傅分库</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仓库名称" style="position: relative">
          <span style="color: red; position: absolute; left: -78px">*</span>
          <a-select @change="onchange33" v-model="storeId" disabled>
            <a-select-option v-for="item in boxLis2" :value="item.storeId">{{ item.storeName }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件" style="position: relative">
          <span style="color: red; position: absolute; left: -50px">*</span>
          <a-select @change="onchange2" v-model="accessoryId" showSearch optionFilterProp="children"
            :filterOption="filterOption" allowClear="true">
            <a-select-option v-for="item in parts" :value="item.accessoryId">{{ item.accessoryType }} _ {{
                item.accessoryName
            }} _ {{ item.accessoryCategory }} _
              {{ item.accessorySpecification }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="出库数量" style="position: relative">
          <span style="color: red; position: absolute; left: -78px">*</span>
          <a-input v-model="accessoryNumber" type="number" @blur="handleblur(1)" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="锁安入库单价" style="position: relative">
          <span style="color: red; position: absolute; left: -108px">*</span>
          <a-input @change="onchange3" disabled v-model="unityPrice" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅配件单价" style="position: relative">
          <span style="color: red; position: absolute; left: -108px">*</span>
          <a-input @change="onchange3" v-model="masterUnityPrice" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业配件总价">
          <a-input v-model="totalPrice" disabled="disabled" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅配件总价">
          <a-input v-model="masterTotalPrice" disabled="disabled" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input v-model="remark2" />
        </a-form-item>
        <div>
          <a-button class="editable-add-btn" @click="handleAdd2">添加</a-button>
          <a-table bordered :dataSource="dataSource2" :columns="columns2">
            <template slot="remark2" slot-scope="text, record">
              <editable-cell :text="text" @change="onCellChange2(record.key, 'remark2', $event)" />
            </template>
            <template slot="operation" slot-scope="text, record">
              <a-popconfirm v-if="dataSource2.length" title="确定删除吗?" @confirm="() => onDelete2(record.key)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
          type="check"
          class="editable-cell-icon-check"
          @click="check"
        />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String
  },
  data() {
    return {
      value: this.text,
      editable: false
    }
  },
  methods: {
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      this.editable = true
    }
  }
}
import {
  selectStorageAccessory,
  saveStorageAccessory,
  selectaccessory,
  selectstore,
  manualinstorage,
  manualoutstorage
} from '@/api/accessory/storageAccessory'
import { selectStoreByStoreType } from '@/api/accessory/commodity'

import pick from 'lodash.pick'
export default {
  name: 'StorageAccessoryModal',
  props: {},
  components: {
    EditableCell
  },
  data() {
    return {
      boxLis4: '',
      parts: '',
      remark2: '',
      // 配件名称
      accessoryName: '',
      // 私有库存数量
      privateNumber: '',
      // 判断阈值是否显示
      threshold: 0,
      // 判断是否是出库
      judge: '',
      // 仓库名称Id
      storeId: '',
      // 入库数量
      accessoryNumber: '',
      // 配件单价
      unityPrice: '',
      // 配件单价
      masterUnityPrice: '',
      // 仓库名称
      storeName: '',
      // 仓库类型
      storeType: '',
      storeTypeName: '',
      // 警戒值
      warningNumber: '',
      // 备注
      remark: '',
      // 总价
      totalPrice: 0,
      masterTotalPrice: 0,
      dataSource: [],
      dataSource2: [],
      count: 0,
      count2: 0,
      // 配件
      accessoryId: '',
      accessoryId2: '',
      columns: [
        {
          title: ' 操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        },
        {
          title: '配件',
          dataIndex: 'accessoryName'
          //width: '20%',
        },
        {
          title: '入库数量',
          dataIndex: 'accessoryNumber'
          // width: '20%',
        },
        {
          title: '锁安入库单价',
          dataIndex: 'unityPrice'
          // width: '20%',
        },
        {
          title: '师傅配件单价',
          dataIndex: 'masterUnityPrice'
          // width: '20%',
        },
        {
          title: '仓库名称',
          dataIndex: 'storeName'
          //  width: '20%',
        },
        {
          title: '仓库类型',
          dataIndex: 'storeTypeName'
          //  width: '20%',
        },
        {
          title: '预警值',
          dataIndex: 'warningNumber',
          scopedSlots: { customRender: 'warningNumber' }
          //   width: '20%',
        },
        // {
        //   title: '总价',
        //   dataIndex: 'totalPrice',
        //   //   width: '20%',
        //
        // },
        {
          title: '备注',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' }
          //  width: '20%',
        }
        // {
        //   title: ' 操作',
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        // },
      ],
      columns2: [
        {
          title: ' 操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        },
        {
          title: '配件',
          dataIndex: 'accessoryName'
          //width: '20%',
        },
        {
          title: '出库数量',
          dataIndex: 'accessoryNumber'
          // width: '20%',
        },
        // {
        //   title: '入库数量',
        //   dataIndex: 'accessoryNumber'
        //   // width: '20%',
        // },
        {
          title: '企业出库单价',
          dataIndex: 'unityPrice'
          // width: '20%',
        },
        {
          title: '师傅出库单价',
          dataIndex: 'masterUnityPrice'
          // width: '20%',
        },
        {
          title: '企业出库总价',
          dataIndex: 'totalPrice'
          // width: '20%',
        },
        {
          title: '师傅出库总价',
          dataIndex: 'masterTotalPrice'
          // width: '20%',
        },
        {
          title: '仓库名称',
          dataIndex: 'storeName'
        },
        {
          title: '仓库类型',
          dataIndex: 'storeTypeName'
          //  width: '20%',
        },
        {
          title: '备注',
          dataIndex: 'remark2',
          //   width: '20%',
          scopedSlots: { customRender: 'remark2' }
        }
      ],
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      boxLis: '',
      boxLis2: '',
      mdl: {},
      vuale: {},
      form: this.$form.createForm(this)
    }
  },
  beforeCreate() { },
  created() { },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    handleblur(value) {
      if (this.accessoryNumber > 0) {
      } else {
        this.$message.success('出库数量不能小于0')
      }
    },

    // 根据仓库类型查询仓库
    onchange4In(value) {
      console.log(value)
      if (value != 2) {
        this.masterUnityPrice = 0
      } else {
        this.masterUnityPrice = ''
      }
      selectStoreByStoreType({ storeType: value }).then(res => {
        console.log(res)
        this.boxLis2 = res.rows
      })
    },
    onchange4(value) {
      selectStoreByStoreType({ storeType: value }).then(res => {
        console.log(res)
        this.boxLis2 = res.rows
      })
    },

    //仓库下拉框

    thresHold2() {
      if (this.threshold == 1) {
        this.threshold = 0
      } else {
        this.threshold = 1
      }
    },

    //获取总价
    onchange3() {
      this.totalPrice = this.unityPrice * this.accessoryNumber
    },
    //获取配件Id
    onchange2(values) {
      console.log(values)
      let boxLis = this.parts
      for (let i = 0; i < boxLis.length; i++) {
        if (boxLis[i].accessoryId == values) {
          this.accessoryId = boxLis[i].accessoryId
          this.accessoryName = boxLis[i].accessoryName
          this.unityPrice = boxLis[i].unityPrice
        }
      }
    },

    // //获取仓库Id和名称
    // onchange(values){
    //   console.log(values)
    //   this.storeId = values
    //   selectStorageAccessory({ storeId: this.storeId }).then(res => {
    //     this.boxLis = res.rows
    //   })
    // },

    //获取仓库Id和名称
    onchange33(values) {
      console.log(values)
      this.storeId = values
      selectStorageAccessory({ storeId: this.storeId }).then(res => {
        this.parts = res.rows
      })
    },

    onCellChange(key, dataIndex, value) {
      const dataSource = [...this.dataSource]
      const target = dataSource.find(item => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.dataSource = dataSource
      }
    },

    onCellChange2(key, dataIndex, value) {
      const dataSource2 = [...this.dataSource2]
      const target = dataSource2.find(item => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.dataSource2 = dataSource2
      }
    },
    onDelete(key) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter(item => item.key !== key)
    },
    onDelete2(key) {
      const dataSource2 = [...this.dataSource2]
      this.dataSource2 = dataSource2.filter(item => item.key !== key)
    },
    handleAdd() {
      if (this.validator()) {
        return
      } else {
        for (let i = 0; i < this.boxLis2.length; i++) {
          if (this.boxLis2[i].storeId == this.storeId) {
            this.storeName = this.boxLis2[i].storeName
          }
        }
        for (let i = 0; i < this.boxLis4.length; i++) {
          if (this.boxLis4[i].accessoryId == this.accessoryId) {
            this.accessoryId = this.boxLis4[i].accessoryId
            this.accessoryName = this.boxLis4[i].accessoryName
          }
        }
        if (this.storeType == 0) {
          this.storeTypeName = '主库'
        } else if (this.storeType == 1) {
          this.storeTypeName = '机构分库'
        } else {
          this.storeTypeName = '师傅分库'
        }

        const { count, dataSource } = this
        const newData = {
          key: count,
          accessoryName: this.accessoryName,
          accessoryId: this.accessoryId,
          storeId: this.storeId,
          accessoryNumber: this.accessoryNumber,
          unityPrice: Number(this.unityPrice),
          masterUnityPrice: Number(this.masterUnityPrice),
          // isPurchaseOrder:this.isPurchaseOrder,
          storeName: this.storeName,
          storeTypeName: this.storeTypeName,
          storeType: this.storeType,
          warningNumber: this.warningNumber,
          remark: this.remark,
          totalPrice: this.totalPrice,
          privateNumber: this.privateNumber
        }
        this.dataSource = [...dataSource, newData]
        this.count = count + 1
      }
    },

    handleAdd2() {
      for (let i = 0; i < this.boxLis2.length; i++) {
        if (this.boxLis2[i].storeId == this.storeId) {
          this.storeName = this.boxLis2[i].storeName
        }
      }
      for (let i = 0; i < this.boxLis.length; i++) {
        if (this.boxLis[i].accessoryId == this.accessoryId) {
          this.accessoryId = this.boxLis[i].accessoryId
          this.accessoryName = this.boxLis[i].accessoryName
        }
      }
      this.totalPrice = this.accessoryNumber * this.unityPrice
      this.masterTotalPrice = this.accessoryNumber * this.masterUnityPrice
      if (this.storeType == 0) {
        this.storeTypeName = '主库'
      } else if (this.storeType == 1) {
        this.storeTypeName = '机构分库'
      } else {
        this.storeTypeName = '师傅分库'
      }
      const { count2, dataSource2 } = this
      const newData = {
        accessoryName: this.accessoryName,
        storeTypeName: this.storeTypeName,
        key: count2,
        accessoryId: this.accessoryId,
        storeId: this.storeId,
        accessoryNumber: this.accessoryNumber,
        unityPrice: Number(this.unityPrice),
        masterUnityPrice: Number(this.masterUnityPrice),
        // isPurchaseOrder:this.isPurchaseOrder,
        storeName: this.storeName,
        storeType: this.storeType,
        // warningNumber:this.warningNumber,
        remark: this.remark2,
        totalPrice: this.totalPrice,
        masterTotalPrice: this.masterTotalPrice,
        storagePrice: this.storagePrice
      }
      this.dataSource2 = [...dataSource2, newData]
      for (var j = 0, total = 0; j < this.dataSource.length; j++) {
        total += parseInt(this.dataSource[j].totalPrice)
      }
      // for(let j=0; j<this.dataSource.length;j++){
      //   this.totalPrice =this.dataSource[j].unityPrice+ this.dataSource[j].unityPrice
      // }
      this.count2 = count2 + 1
    },

    add() {
      this.unityPrice = ''
      this.masterUnityPrice = ''
      this.dataSource = []
      this.accessoryId = ''
      this.parts = ''
      this.remark2 = ''
      // 配件名称
      this.accessoryName = ''
      // 私有库存数量
      this.privateNumber = ''
      // 判断阈值是否显示
      this.threshold = 0
      // 判断是否是出库
      this.judge = ''
      // 仓库名称Id
      this.storeId = ''
        // 入库数量
        ; (this.accessoryNumber = ''),
          // 配件单价
          (this.unityPrice = '')
      // 仓库名称
      this.storeName = ''
      // 仓库类型
      this.storeType = ''
      this.storeTypeName = ''
      // 警戒值
      this.warningNumber = ''
      // 备注
      this.remark = ''
      // 总价
      this.totalPrice = 0

      this.form.resetFields()
      this.edit({ storageAccessoryId: 0 })

      selectaccessory().then(res => {
        console.log(res)
        this.boxLis4 = res.rows
        console.log(this.boxLis)
      })

      // selectstore().then(res => {
      //   console.log(res)
      //   this.boxLis2 = res.rows
      //   console.log(this.boxLis2)
      // })
    },

    //出库
    edit2(record) {
      console.log('res', record)
      this.totalPrice = 0
      this.masterTotalPrice = 0
      this.storeId = record.storeId
      this.accessoryNumber = ''
      this.dataSource2 = []
      // storeId 仓库名称   unityPrice 配件单价  storeType仓库类型 accessoryId
      this.judge = 1
      this.visible = true
      // this.onchange(record.storeId)
      selectaccessory().then(res => {
        if (!res.rows.length) return
        this.boxLis = res.rows
        console.log(this.boxLis)

        //this.accessoryId = res.rows[0].accessoryId
      })

      selectstore().then(res => {
        if (!res.rows.length) return
        // this.storeId = res.rows[0].storeId
        this.storeName = res.rows[0].storeName
        // this.storeType = res.rows[0].storeType
        this.boxLis2 = res.rows
        console.log(this.boxLis2)
      })
      selectStorageAccessory({ storeId: this.storeId }).then(res => {
        this.parts = res.rows
      })
      //this.accessoryId2=record.accessoryId
      this.accessoryId = record.accessoryId

      this.unityPrice = record.unityPrice
      this.masterUnityPrice = record.masterUnityPrice
      this.storeType = record.storeType
      this.storeId = record.storeId
      this.parts = this.parts
    },

    edit(record) {
      console.log(record)
      this.mdl = Object.assign(record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.mdl,
            'storageAccessoryId',
            'storeId',
            'accessoryId',
            'privateNumber',
            'accessoryNumber',
            'unityPrice',
            'warningNumber',
            'forbiddenStatus',
            'createBy',
            'createTime',
            'updateBy',
            'updateTime'
          )
        )
      })
    },
    handleSubmit(e) {
      if (this.validator()) {
        return
      } else {
        console.log(this.dataSource)
        console.log(this.dataSource2, 'this.dataSource2')
        // this.confirmLoading = true
        //this.dataSource2[0].accessoryId=this.accessoryId2

        if (this.judge == 1) {
          if (this.dataSource2.length == 0) {
            return this.$message.error('请添加配件')
          }
          this.confirmLoading = true
          manualoutstorage(this.dataSource2)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok')
                this.confirmLoading = false
                this.visible = false
              } else if (res.code === -1) {
                this.$message.success('库存不足')
                this.confirmLoading = false
              } else {
                this.$message.success(res.msg)
                this.confirmLoading = false
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
              this.confirmLoading = false
            })
        } else {
          // 入库
          // debugger

          if (this.dataSource.length == 0) {
            return this.$message.error('请添加配件')
          }
          console.log(this.dataSource)
          manualinstorage(this.dataSource)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok')
                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              // this.confirmLoading = false
            })
        }
      }
    },

    validator() {
      if (this.storeType == '' || this.storeType == null || this.storeType == undefined) {
        this.$message.success('仓库类型不能为空')
        return true
      }
      if (this.storeId == '' || this.storeId == null || this.storeId == undefined) {
        this.$message.success('仓库名称不能为空')
        return true
      }
      if (this.accessoryId == '' || this.accessoryId == null || this.accessoryId == undefined) {
        this.$message.success('配件不能为空')
        return true
      }

      if (
        this.accessoryNumber == '' ||
        this.accessoryNumber == null ||
        (this.accessoryNumber == undefined && this.accessoryNumber < 0)
      ) {
        this.$message.success((this.judge == 1 ? '出' : '入') + '库数量不能为空')
        return true
      }
      if (this.judge != 1 && !this.unityPrice) {
        this.$message.success('锁安入库单价不能为空')
        return true
      }
      //0=='' true 所以将Number的0转为String的0
      // console.log(typeof this.masterUnityPrice)
      if (String(this.masterUnityPrice) == '' || this.masterUnityPrice == null || this.masterUnityPrice == undefined) {
        this.$message.success('师傅配件单价不能为空')
        return true
      }
      // console.log(typeof this.masterUnityPrice)
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
